import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/common";
import { useGarage } from "@/context/GarageContext";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { t } from "@/i18n";

const DONE = ["paid", "no_payment_required"];

export default function BillingReturn() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const { reload } = useGarage();
  const { refresh } = useAuth();
  const [state, setState] = useState("checking");

  useEffect(() => {
    let tries = 0;
    let timer;
    const poll = async () => {
      tries += 1;
      try {
        const { data } = await api.get(`/garage/subscription/checkout/${sessionId}`);
        if (DONE.includes(data.payment_status) || data.status === "completed") {
          setState("ok");
          reload();
          refresh();
          return;
        }
        if (["expired", "failed"].includes(data.status)) return setState("failed");
      } catch {
        return setState("failed");
      }
      if (tries >= 10) return setState("pending");
      timer = setTimeout(poll, 2000);
    };
    if (sessionId) poll();
    else setState("failed");
    return () => clearTimeout(timer);
  }, [sessionId]); // eslint-disable-line react-hooks/exhaustive-deps

  const view = {
    checking: [Loader2, "animate-spin text-slate-400", t("p7.billing.returnTitle")],
    ok: [CheckCircle2, "text-emerald-600", t("p7.billing.returnOk")],
    pending: [Loader2, "text-amber-500", t("p7.billing.returnPending")],
    failed: [XCircle, "text-red-600", t("p7.billing.returnFailed")],
  }[state];
  const [Icon, cls, text] = view;
  return (
    <Card className="mx-auto mt-10 max-w-lg p-10 text-center" testId="billing-return">
      <Icon className={`mx-auto h-12 w-12 ${cls}`} />
      <p className="mt-6 font-display text-2xl font-bold text-slate-900" data-testid="billing-return-status" data-state={state}>{text}</p>
      <Button asChild className="mt-8" data-testid="billing-return-settings-link"><Link to="/pro/settings?tab=plan">{t("p7.billing.backToSettings")}</Link></Button>
    </Card>
  );
}
